import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import commonActions from "../common/actions";
import candidatesActions from "./actions";
import objectionTrackActions from "./actions";
import axios from "axios";
// import { API_URL } from "../../utils/constants";
import masterActions from "../master/action";
import authActions from "../auth/actions";
import Cookies from "js-cookie";
import { calculateDaysDifference, formatDate } from "../../utils/validations";
import {
  EncryptFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";
import { downloadBase64 } from "../../utils/downloadBase64";
import { ExternalError,InternalError } from "../../common/ErrorMessage";

const objectionTrackerSaga = function* () {
  yield all([
    yield takeEvery(objectionTrackActions.GET_OBJECTION_TRACKER, getObjectionQuestions),
    yield takeEvery(objectionTrackActions.GET_ANSWER_KEY, getAnswerKeys),
    yield takeEvery(objectionTrackActions.GET_ROLL_NO, getRollNo),
    yield takeEvery(objectionTrackActions.GET_OBJECTION_COURSES, getObjectionCourses),
    yield takeEvery(objectionTrackActions.RAISE_OBJECTION_DETAILS_CREATION, raiseObjectionDetailsCreation),
    yield takeEvery(objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,getCandidateObjectionDetails),
    yield takeEvery(objectionTrackActions.GET_OBJECTION_DELETE,DeleteCandidateObjectionDetails),
    yield takeEvery(objectionTrackActions.RAISE_OBJECTION_BUTTON_CLICK,RaiseObjectionButtonClick),





  ]);
};

const getObjectionQuestions = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/objection/${encodeURIComponent(EncryptFunction(payload.courseid))}`)
    );
    yield put({
      type: objectionTrackActions.SET_OBJECTION_TRACKER,
      payload: result?.data?.questionData,
    });
    yield call(ExternalError,result)
  } catch (err) {
     yield call(InternalError,err)
  }
};


const getObjectionCourses = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/objectiontrack-courses/${encodeURIComponent(EncryptFunction(payload?.candidateid))}`)
    );
        const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    })
    yield put({
      type: objectionTrackActions.SET_OBJECTION_COURSES,
      payload: decryptedData,
    });
     yield call(ExternalError,result)
  } catch (err) {
     yield call(InternalError,err)
  }
};



const getRollNo = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/answerkeys`)
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.courseData,
    });

    yield put({
      type: objectionTrackActions.SET_ROLL_NO,
      payload: decryptedData,
    });
    yield call(ExternalError,result)
  } catch (err) {
     yield call(InternalError,err)
  }
};

const getAnswerKeys = function* (data) {
  const { payload } = data;
  const { candidateid, courseid, rollno } = payload;

  

  try {
    const result = yield call(() =>
      axios.get(`${process.env.REACT_APP_API_URL}/answerkeys/${candidateid}/${courseid}/${encodeURIComponent(EncryptFunction(rollno))}`)
    );

    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });

    yield put({
      type: objectionTrackActions.SET_ANSWER_KEY,
      payload: decryptedData,
    });
    yield call(ExternalError,result)
  } catch (err) {
     yield call(InternalError,err)
  }
};


const raiseObjectionDetailsCreation = function* (data) {
  const { payload } = data;
  const { resetForm, } = payload;
  
  const formData = new FormData();
  let { docurl,questiondetails,handleCloseDialog, ...formDatas } = payload?.data;

  // Append all other fields except docurl
  for (let key in formDatas) {
    formData.append(key, payload?.data[key]);
  }

  // Handle the file for docurl
  if (payload?.data?.docurl?.file !== null) {
    const file = new File(
      [payload?.data?.docurl], 
      payload?.data?.docurl?.name, 
      { type: payload?.data?.docurl?.type }
    );
    formData.append("docurl", file);
  }
  
  

      
      const b64 = payload?.data?.questiondetails?.question?.props?.src



if (b64) {
  // Convert Base64 to Binary (Blob)
  const byteCharacters = atob(b64.split(",")[1]); // Decode Base64
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: "image/png" });

  // Convert Blob to File
  const file = new File([blob], payload?.data?.questiondetails?.question?.props?.alt, { type: "image/png"});

  // Append file to FormData
  formData.append("questiondetails", file);
}

  // Show loading spinner
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    // Send formData to the API
    const result = yield call(() =>
      axios.post(`${process.env.REACT_APP_API_URL}/raiseobjection`, formData, {
        headers: {
          "Content-Type": "multipart/form-data", // Ensures files are sent properly
        },
      })
    );

    // Stop loading spinner
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    // Show the alert based on the result from the API
    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });


    yield put({
      type: objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,
      payload: { candidateid : payload?.data?.candidateid, courseid : payload?.data?.courseid },
     });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

    // If success, reset form and navigate
    if (result?.data?.statusCode === 200) {
      // yield delay(1000);;
      handleCloseDialog()
      resetForm();
    }
  } catch (err) {
     yield call(InternalError,err)
  }

  // Hide the button loader in case of failure
  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};



const getCandidateObjectionDetails = function* (data) {
  const { payload } = data;
  const { candidateid, courseid } = payload;
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(1000);;
  // yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });
  
  try {
    if(candidateid && courseid){
    const result = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_URL}/candidate/obj-details/${encodeURIComponent(EncryptFunction(candidateid))}/${encodeURIComponent(EncryptFunction(courseid))}`
      ) 
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    yield put({
      type: objectionTrackActions.SET_CANDIDATE_OBJECTION_DETAILS,
      payload: decryptedData,
    });
    yield call(ExternalError,result)
  }
  }catch (err) {
     yield call(InternalError,err)
  }
};



const DeleteCandidateObjectionDetails = function* (data) {
  const { payload } = data;

  
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(1000);;
  try {
    const result = yield call(() =>
      axios.delete(
        `${process.env.REACT_APP_API_URL}/delete-objection/${encodeURIComponent(EncryptFunction(payload.objectionquestionid))}`
      )
    );
    // const decryptedData = yield call(handleDecodeJSON, {
    //   decodeJSON: result?.data?.result,
    // });
    yield put({
      type: objectionTrackActions.SET_OBJECTION_DELETE,
      payload: result?.data.result,
    });


    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,
      payload: { candidateid : payload?.candidateid, courseid : payload?.courseid },
     });

     yield delay(2000);
     yield put({
       type: commonActions.SET_ALERT,
       payload: { status: null, show: false, message: null },
     });

  } catch (err) {
     yield call(InternalError,err)
  }
};

const RaiseObjectionButtonClick = function* (data) {
  const { payload } = data;

  
  // yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  // yield delay(1000);;
  try {
    const result = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/raise-objection-click/${encodeURIComponent(EncryptFunction(payload?.candidateid))}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`,
        { 
          click: payload?.click,
          obj_data: payload?.objectionDetails ,
          objectionId: payload?.objectionId
        }
      )
    );
   
    yield call(ExternalError,result)
  } catch (err) {
     yield call(InternalError,err)
  }
};




  



export default objectionTrackerSaga;
